import { render } from "./GoalDate.vue?vue&type=template&id=6a9165f0"
import script from "./GoalDate.vue?vue&type=script&lang=js"
export * from "./GoalDate.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__